import React, { useState } from 'react';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { CollapsiblePanelProps } from './types';
import { styles } from './styles';

export const CollapsiblePanel: React.FC<CollapsiblePanelProps> = ({
  title,
  children,
  defaultExpanded = false,
  expanded: controlledExpanded,
  onToggle,
  className,
}) => {
  const [internalExpanded, setInternalExpanded] = useState(defaultExpanded);

  const isControlled = controlledExpanded !== undefined;
  const isExpanded = isControlled ? controlledExpanded : internalExpanded;

  const handleToggle = () => {
    const newExpanded = !isExpanded;

    if (!isControlled) {
      setInternalExpanded(newExpanded);
    }

    onToggle?.(newExpanded);
  };

  return (
    <div className={clsx(styles.container, className)}>
      <div
        role="button"
        tabIndex={0}
        onClick={handleToggle}
        onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleToggle();
          }
        }}
        className={styles.header}
        aria-expanded={isExpanded}>
        <span className={styles.title}>{title}</span>
        <FontAwesomeIcon
          icon={faChevronDown}
          className={clsx(styles.icon, isExpanded && styles.iconExpanded)}
        />
      </div>
      {isExpanded && <div className={styles.content}>{children}</div>}
    </div>
  );
};

export type { CollapsiblePanelProps } from './types';
export default CollapsiblePanel;
